const REACT_APP_API = process.env.REACT_APP_API;
// const REACT_APP_API ="https://mashroom-node.herokuapp.com/api/";
export { REACT_APP_API };
